import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';

export const AddAllButton = ({
  buttonString,
  addAllToCart,
  buttonStyle,
  disabled,
  themeStyle,
}) =>
  disabled ? (
    <button className={buttonStyle}>{buttonString}</button>
  ) : (
    <button
      disabled={disabled}
      className={buttonStyle}
      style={themeStyle}
      onClick={addAllToCart}
    >
      {buttonString}
    </button>
  );

AddAllButton.propTypes = {
  buttonString: PropTypes.string.isRequired,
  addAllToCart: PropTypes.func.isRequired,
  buttonStyle: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default enhance(AddAllButton);
